
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: 'Embed subscription management into your digital banking experience'
};
export const partnerProps = {
  partner: 'ScribeUp',
  clientLibrary: 'scribeup',
  subtitle: metadata.description,
  registrationUrl: 'https://www.scribeup.io/partners',
  apiUrl: 'https://docs.scribeup.io/',
  isPaymentProcessor: false
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`ScribeUp and Plaid have partnered to transform how financial institutions empower their users to manage subscriptions effortlessly. By integrating Plaid's APIs with ScribeUp's subscription management technology, banks, credit unions, and fintechs can now offer a seamless, embedded solution within their digital banking platforms.`}</p>
    <p>{`With the ScribeUp + Plaid integration, users gain unparalleled control over their recurring expenses. They can instantly identify subscriptions linked to their accounts or cards, uncovering payments they may not even realize they're making. Even better, users don't need to re-link accounts they've already connected in the past, creating a frictionless experience that gets them started immediately. From detecting subscriptions to canceling them with a single click, users can now manage their recurring expenses directly within your mobile or desktop banking app.`}</p>
    <p>{`The integration also ensures users stay ahead of their recurring bills with timely notifications and calendar syncing, preventing missed payments and unnecessary fees. By embedding ScribeUp's subscription management suite, powered by Plaid, into your banking experience, you're not only enhancing user satisfaction but also strengthening their trust and engagement with your institution.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.Instructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
